import * as actions from "../../api";
import * as calculationAction from "../../actions";

export const fetchSavedResultByIdApi = (id) => actions.saveResultByIdAPI(id);

export const updateCalculatedCostApi = (id, data) => calculationAction.updateCalculatedCostDetails(id, data);

export const addOperationSingleVesselApi = (data) => calculationAction.addCargoExtraDetailsForSingleVessel(data);

export const deleteOperationSingleVesselApi = (data) => calculationAction.deleteCargoExtraDetailForSingleVessel(data);

export const sendCalculatorDataApi = (data) => calculationAction.sendCalculatorData(data);

export const getPortDistanceByPortListApi = (data) => calculationAction.getPortDistanceByPortList(data);

export const resetDistanceApi = (data) => calculationAction.resetDistance(data);

export const savePortDistanceApi = (data) => calculationAction.savePortDistance(data);
